import { render, staticRenderFns } from "./pullNewList.vue?vue&type=template&id=62209541&scoped=true&"
import script from "./pullNewList.vue?vue&type=script&lang=js&"
export * from "./pullNewList.vue?vue&type=script&lang=js&"
import style0 from "./pullNewList.vue?vue&type=style&index=0&id=62209541&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62209541",
  null
  
)

export default component.exports